import { api } from "@/services";
import { useFilter } from "@/utilsV2";
import { UseToastOptions } from "@chakra-ui/react";
async function useBasicHasRegister(Options: {
    UserEmail?: string;
    UserDocument?: string;

    ModalTrigger?: () => void;
    ToastTrigger?: (Options: UseToastOptions) => void;
    SetHasRegister?: (HasRegister: boolean) => void;
    SetResponse?: (Response: {
        status: boolean;
        msgs: string | string[];
    }) => void;
}): Promise<
    [
        Response: { status: boolean; msgs: string | string[] } | null,
        Error: string | string[] | null,
        Loading: boolean
    ]
> {
    var Response = <{ status: boolean; msgs: string | string[] }>(
        ({} as { status: boolean; msgs: string | string[] })
    );
    var Error = null;
    var Loading = true;

    const Controller = new AbortController();

    const MakeRequest = async () => {
        try {
            const DOC = useFilter(Options.UserDocument ?? "", {
                type: "number",
            });

            const resp: { data: { status: boolean; msgs: string | string[] } } =
                await api.get(
                    `/Client/Exists?cpf=${DOC}&cnpj=${null}&email=${
                        Options.UserEmail
                    }`
                );
            Response = resp.data;
        } catch (error) {
            Error = [
                "Não foi possível verificar se o usuário já está cadastrado.",
                error.message,
            ];
        } finally {
            Loading = false;
        }
    };

    await MakeRequest();

    Controller.abort();

    return [Response, Error, Loading];
}

export { useBasicHasRegister };
